export default __webpack_public_path__ + "cce51b4e0d302248a5fbb406d7550797.png";